module.exports = __webpack_public_path__ + "static/channels-table-08c4e6ef0816aafe9c0a203154e08535.svg";